import { useEffect, useState } from "react";
import { loadScript, route } from "../../../globals/constants";
import FastImage from "../../../globals/elements/fastimg";
import { NavLink } from "react-router-dom";
import _data from "../../../globals/data/data.json";
import { getPortalPage } from "../../../utils/func";
import PageBody from '../pageBody'
import SEO from '../seo'

function Home1Page({ layoutInfo }) {

    const { clients } = _data;

    const [pageInfo,setPageInfo] = useState(null)

    useEffect(() => {
        loadPortalInfo()
    },[])

    function loadPortalInfo() {
        getPortalPage().then(result => {
            setPageInfo(result[0])
        }).catch(err => {

        })
    }

    const body = pageInfo?.body;


    useEffect(() => {
        loadScript("js/custom.js");
    })

    return (
        <>
            <SEO 
                siteName={layoutInfo?.site_name}
                pageTitle={pageInfo ? pageInfo?.name : "home page" }
                description={layoutInfo?.description}
                keywords={layoutInfo?.keywords}
            />
            {
                body && (
                    <PageBody 
                        body={JSON.parse(body)}
                        formspree_id={layoutInfo?.formspree_id}
                    />
                )
            }     
           
            {/* Our Client Logo */}
            <div className="section-full bg-white p-tb50">
                <div className="container">
                    <div className="section-content">
                        <div className="owl-carousel home-client-logo owl-btn-vertical-center">

                            {
                                clients.map((_item, index) => {
                                    return <div key={index} className="item">
                                        <div className="ow-client-logo">
                                            <div className="client-logo mt-img-effect on-color">
                                                <NavLink to={route.pages.team.TEAM}><FastImage src={_item} alt="" /></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Home1Page;